import ChatWidget from './components/ChatWidget/ChatWidget';
import { ChatProvider } from './context/ChatContext';
import { AuthProvider } from './context/AuthContext';
import { useInternalEventEmitter } from './hooks/useInternalEventEmitter';
import type { ChatConfig, TokenData } from './types/chat.types';
import './App.css';

type Extension = {
  type: 'loginTracker';
  component: React.ComponentType;
};

type AppProps = {
  config: ChatConfig;
  getToken?: () => Promise<TokenData>;
  getEntraToken?: () => Promise<string | null>;
  startLogin?: () => Promise<any>;
  getOpcoContextData?: () => object;
  autoInputToTriage?: string;
  isLivechatAvailable?: () => boolean;
  extensions?: Extension[];
  lazyInit?: boolean;
};

const App: React.FC<AppProps> = ({
  config,
  getToken,
  getEntraToken,
  startLogin,
  getOpcoContextData,
  autoInputToTriage,
  isLivechatAvailable,
  extensions,
  lazyInit,
}) => {
  const internalEventEmitter = useInternalEventEmitter();

  return (
    <div className="chatbot-widget-root">
      <AuthProvider getToken={getToken} getEntraToken={getEntraToken}>
        <ChatProvider internalEventEmitter={internalEventEmitter} config={config}>
          {extensions?.map((ext, idx) => {
            const Component = ext.component;
            return <Component key={`${ext.type}-${idx}`} />;
          })}
          <ChatWidget
            config={config}
            startLogin={startLogin}
            autoInputToTriage={autoInputToTriage}
            isLivechatAvailable={isLivechatAvailable}
            getOpcoContextData={getOpcoContextData}
            lazyInit={lazyInit}
          />
        </ChatProvider>
      </AuthProvider>
    </div>
  );
};

export default App;
